import { h } from 'preact';
import style from './style';
import { Icon } from '@cube/blocks';
import cx from 'classnames';

/**
 * Render the Current Weather component
 * @param  {Object} The current alerts, and postal code, for this location
 * @return {String} The rendered component
 */
const WeatherAlerts = ({
	alertColor,
	alertLevel,
	alertCount,
	alertText,
	alertURL,
	openNewWindow
}) => {
	let additionalAttributes = openNewWindow ? { target: '_blank', rel: 'noopener noreferrer' } : {};
	return (
		<a href={alertURL} {...additionalAttributes}>
			<div class={cx(style.alert, style[alertLevel])} style={getAlertColor(alertColor)}>
				<div class={cx(style.message)}>
					 {alertText}
				</div>
				<div class={cx(style.more)}>
					<Icon name="alert-wire-cube" /> {alertCount}
				</div>
			</div>
		</a>
	);
};

export const getAlertColor = color => (
	'background: ' + color
);

export default WeatherAlerts;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/alert/index.js